import React from "react";
import { useLang } from "../lib/LangContext";
import { Sparkles, BadgeDollarSign, Film } from "lucide-react";

const About = () => {
  const { t } = useLang();
  const pillars = [
    { icon: Sparkles, title: t.about.pillar1Title, desc: t.about.pillar1Desc },
    { icon: BadgeDollarSign, title: t.about.pillar2Title, desc: t.about.pillar2Desc },
    { icon: Film, title: t.about.pillar3Title, desc: t.about.pillar3Desc },
  ];

  return (
    <section id="about" data-testid="about-section" className="relative bg-black py-20 md:py-28">
      <div className="max-w-screen-2xl mx-auto px-6 md:px-12 lg:px-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-5">
              <div className="h-px w-8 bg-brand-yellow" />
              <span className="text-[11px] uppercase tracking-[0.4em] text-brand-yellow font-semibold">
                {t.about.eyebrow}
              </span>
            </div>
            <h2 className="font-anton uppercase text-white leading-[0.95]" style={{ fontSize: "clamp(2rem, 4.5vw, 3.75rem)" }}>
              {t.about.title}
            </h2>
          </div>
          <div className="lg:col-span-7 flex flex-col gap-5">
            <p className="text-white/70 text-sm md:text-base lg:text-lg leading-relaxed">{t.about.p1}</p>
            <p className="text-white/60 text-sm md:text-base lg:text-lg leading-relaxed">{t.about.p2}</p>
          </div>
        </div>

        {/* Pillars */}
        <div className="mt-16">
          <div className="text-[11px] uppercase tracking-[0.4em] text-white/50 mb-6">
            {t.about.pillarsTitle}
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-white/10">
            {pillars.map((p, i) => {
              const Icon = p.icon;
              return (
                <div
                  key={i}
                  data-testid={`about-pillar-${i}`}
                  className="group bg-black p-6 md:p-8 hover:bg-[#0a0a0a] transition-colors relative overflow-hidden"
                >
                  <div className="absolute top-0 left-0 right-0 h-px bg-brand-yellow scale-x-0 group-hover:scale-x-100 origin-left transition-transform duration-500" />
                  <Icon size={30} className="text-brand-yellow mb-4 group-hover:animate-pulse-glow" strokeWidth={1.4} />
                  <div className="font-anton uppercase text-xl md:text-2xl text-white tracking-wide mb-2">
                    {p.title}
                  </div>
                  <p className="text-white/60 leading-relaxed text-sm">{p.desc}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
